import request from '@/utils/httpRequest';

export default class LeasingService {

  getProjects() {
    return request({
      url: '/testApi/getProjects',
      method: 'post',
      params: {}
    });
  }

 getFloor(projectId) {
   return request({
     url: '/testApi/getFloor',
     method: 'post',
     params: {projectId: projectId}
   });
 }
 
 getLeasing(projectId, buildingId) {
   return request({
     url: '/testApi/getLeasing',
     method: 'post',
     params: {projectId: projectId, buildingId: buildingId}
   });
 }

}
